export const LOGO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_final-wishes-11/artifacts/ua7z0gal_22B35E2A-760D-4089-8613-F9953CBA2B7F.png";
